import { ReactNode } from "react";
import { TOGGLE_FEATURE } from "@jasper/shared";
import {
  IconChartBarPopular,
  IconPencil,
  IconPlugX,
  IconCubeSend,
  IconTruckReturn,
  IconPlane,
  IconUsersGroup,
  IconUsers,
  IconHourglass,
  IconSettings,
  IconPackageImport,
  IconPlayerPause,
} from "@tabler/icons-react";
import { OrderStatus } from "/@/generated/graphql.ts";

export interface NavMenuLink {
  title: string;
  path: string;
  icon: ReactNode;
}

export interface ProviderStatusLink {
  title: string;
  status: OrderStatus;
  notificationNumber?: number;
  icon: ReactNode;
}

export const getStaffLinks = (email?: string): NavMenuLink[] => [
  ...(email && TOGGLE_FEATURE.DATA_PAGE(email)
    ? [{ title: "DATA", path: "/data", icon: <IconChartBarPopular /> }]
    : []),
  { title: "ORDER DESIGN", path: "/order-designs", icon: <IconPencil /> },
  { title: "UNHANDLED CASES", path: "/external-cases", icon: <IconPlugX /> },
  {
    title: "PRINT CARRIER LABELS",
    path: "/ops/shipping",
    icon: <IconCubeSend />,
  },
  { title: "PICKUPS", path: "/pickups", icon: <IconTruckReturn /> },
  { title: "BACK TO CHINA", path: "/back-to-china", icon: <IconPlane /> },
];

export const getStaffAndAdminLinks = (): NavMenuLink[] => [
  { title: "GROUPS", path: "/groups", icon: <IconUsersGroup /> },
  { title: "USERS", path: "/users", icon: <IconUsers /> },
];

export const getProviderStatusLinks = (
  newCases: number
): ProviderStatusLink[] => [
  {
    title: OrderStatus.WaitingForProduction,
    status: OrderStatus.WaitingForProduction,
    notificationNumber: newCases,
    icon: <IconHourglass />,
  },
  {
    title: OrderStatus.Producing,
    status: OrderStatus.Producing,
    icon: <IconSettings />,
  },
  {
    title: "SHIPPED TO FRANCE",
    status: OrderStatus.ProducingInTransit,
    icon: <IconPlane />,
  },
  {
    title: OrderStatus.Delivered,
    status: OrderStatus.Delivered,
    icon: <IconPackageImport />,
  },
  {
    title: OrderStatus.OnHold,
    status: OrderStatus.OnHold,
    icon: <IconPlayerPause />,
  },
];
